import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import axiosInstance from "../Axios";
import SmartClassesTable from "../components/smartclassestable/SmartClassesTable";
import StackedAreaChart from "../components/stackedareachart/StackedAreaChart";
import useAuth from "../contexts/UserContext.tsx";
import { useGlobalContext } from "../contexts/GlobalContext.jsx";

const SchoolReport = () => {
  const { schoolID } = useParams();
  const [school, setSchool] = useState("");
  const { user, logout } = useAuth();
  const [reload, setReload] = useState(false);
  const [smartClassesOpsData, setSmartClassesOpsData] = useState([]);
  const [schoolKPIData, setSchoolKPIData] = useState();
  const [schoolCommunicationDetails, setSchoolCommunicationDetails] =
    useState();
  const [teacherStatusData, setTeacherStatusData] = useState();
  const { yearlySummaryData } = useGlobalContext();
  const navigate = useNavigate();

  const getSchoolKPIDataBySchool = async () => {
    try {
      const res = await axiosInstance.post("getSchoolKPIBySchool", {
        auth_token: user.auth_token,
        school_id: schoolID,
        user_id: user.user_id,
      });
      setSchoolKPIData(res.data.data.school_kpi);
    } catch (err) {
      console.error(err.message);
    }
  };

  const getSmartClassesOpsData = async () => {
    try {
      const res = await axiosInstance.post("getSmartClassOpsStatusBySchool", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_id: schoolID,
      });
      if (res.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      setSmartClassesOpsData(res.data.data.smartclass_ops_status);
    } catch (err) {
      toast.error("Error getting class data.");
    }
  };

  const getSchoolNameByID = async () => {
    await axiosInstance
      .post("getSchoolNameByID", {
        school_id: schoolID,
        user_id: user.user_id,
        auth_token: user.auth_token,
      })
      .then((res) => {
        setSchool(res.data.data.school_name[0].school_name);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getCommunicationDetails = async () => {
    try {
      const res = await axiosInstance.post("getschoolfollowup", {
        user_id: user.user_id,
        school_id: schoolID,
        auth_token: user.auth_token,
      });
      // console.log("Communication details", res.data.data.school_followups);
      let data = res.data.data.school_followups;
      data = data.map((comm, idx) => {
        comm = {
          ...comm,
          id: idx,
        };
        return comm;
      });
      setSchoolCommunicationDetails(data);
    } catch (err) {
      console.error(err.message);
    }
  };

  const getTeacherStatusData = async () => {
    try {
      const res = await axiosInstance.post("getTeacherStatus", {
        school_id: schoolID,
        auth_token: user.auth_token,
      });
      setTeacherStatusData(res.data.data.response);
    } catch (err) {
      console.error(err.message);
    }
  };

  useEffect(() => {
    getSmartClassesOpsData();
    // getTeachersBySchools();
    getSchoolKPIDataBySchool();
    getCommunicationDetails();
    getTeacherStatusData();
    getSchoolNameByID();

    if (reload) {
      setReload(false);
    }
    if (!yearlySummaryData) {
      toast.error("Error getting yearly data. Please try later.");
      navigate("/school/" + schoolID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <>
      <div className="container school p-3 h-auto">
        <div className="gap-2 mb-4">
          <img
            className="absolute left-10 top-3"
            src={`${process.env.PUBLIC_URL}/aveti.png`}
            alt="aveti-logo"
          />
          <div className="font-sans text-2xl text-[#7974d7] mb-10 text-center">
            {school}
          </div>

          <div className="grid grid-cols-3 mx-auto w-fit gap-x-10">
            <div className="detailItem">
              <span className="itemKey font-bold">Headmaster: </span>
              <span className="itemValue">
                {smartClassesOpsData &&
                  smartClassesOpsData.length > 0 &&
                  smartClassesOpsData[0].hm_name}
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">Phone: </span>
              <span className="itemValue">
                {smartClassesOpsData &&
                  smartClassesOpsData.length > 0 &&
                  smartClassesOpsData[0].hm_phone}
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">Smart Classes : </span>
              <span className="itemValue">
                {schoolKPIData && schoolKPIData.center_cnt}
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">Total Video Usage: </span>
              <span className="itemValue">
                {schoolKPIData &&
                  Intl.NumberFormat("en-US", {
                    notation: "compact",
                    compactDisplay: "short",
                  }).format(schoolKPIData.video_usage_cnt)}{" "}
                Minutes
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">Total Exercise Usage: </span>
              <span className="itemValue">
                {schoolKPIData &&
                  Intl.NumberFormat("en-US", {
                    notation: "compact",
                    compactDisplay: "short",
                  }).format(schoolKPIData.excs_usage_cnt)}{" "}
                Minutes
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">Teachers: </span>
              <span className="itemValue">
                {schoolKPIData && schoolKPIData.teacher_cnt}
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">
                Current Year Video Usage:{" "}
              </span>
              <span className="itemValue">
                {yearlySummaryData &&
                  Intl.NumberFormat("en-US", {
                    notation: "compact",
                    compactDisplay: "short",
                  }).format(yearlySummaryData.yearly_video_usage_cnt)}{" "}
                Minutes
              </span>
            </div>
            <div className="detailItem">
              <span className="itemKey font-bold">
                Current Year Exercise Usage:{" "}
              </span>
              <span className="itemValue">
                {yearlySummaryData &&
                  Intl.NumberFormat("en-US", {
                    notation: "compact",
                    compactDisplay: "short",
                  }).format(yearlySummaryData.yearly_excs_usage_cnt)}{" "}
                Minutes
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-[1080px] mx-auto">
        <StackedAreaChart schoolID={schoolID} title="Smart Class Usage" />
      </div>
      <SmartClassesTable
        data={smartClassesOpsData}
        schoolData={school}
        reportMode={true}
      />

      {/* Teachers Data Table */}
      <TableContainer
        component={Paper}
        className="mt-6 px-4"
        sx={{ boxShadow: "2px 4px 10px 1px rgba(201, 201, 201, 0.47)" }}
      >
        <div className="flex justify-between items-center">
          <span className="font-bold p-4">Smart Class Operation Status</span>
        </div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Sl No.</TableCell>
              <TableCell>Teacher Name</TableCell>
              <TableCell>Video Usage (min)</TableCell>
              <TableCell>Exercise Usage (min)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teacherStatusData && teacherStatusData.length > 0 ? (
              teacherStatusData.map((teacher, idx) => (
                <TableRow key={idx}>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>{teacher.Teacher_Name}</TableCell>
                  <TableCell>
                    {Intl.NumberFormat("en-US", {
                      notation: "compact",
                      compactDisplay: "short",
                    }).format(teacher.video_usage)}
                  </TableCell>
                  <TableCell>
                    {Intl.NumberFormat("en-US", {
                      notation: "compact",
                      compactDisplay: "short",
                    }).format(teacher.excs_usage)}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TableContainer
        component={Paper}
        className="mt-6 px-4"
        sx={{ boxShadow: "2px 4px 10px 1px rgba(201, 201, 201, 0.47)" }}
      >
        <div className="flex justify-between items-center">
          <span className="font-bold p-4">Communication Details</span>
        </div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                className="w-28"
                style={{
                  fontWeight: "bold",
                }}
              >
                Date
              </TableCell>
              <TableCell
                className="w-48"
                style={{
                  fontWeight: "bold",
                }}
              >
                Communication Type
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                }}
              >
                Title
              </TableCell>
              <TableCell
                style={{
                  fontWeight: "bold",
                }}
              >
                Message
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schoolCommunicationDetails &&
            schoolCommunicationDetails.length > 0 ? (
              schoolCommunicationDetails.map((communication, idx) => {
                if (
                  communication.comm_type === "VirtualMeeting" ||
                  communication.comm_type === "Low_Usage_Call"
                ) {
                  return (
                    <TableRow key={idx}>
                      <TableCell>{communication.comm_date}</TableCell>
                      <TableCell>{communication.comm_type}</TableCell>
                      <TableCell>{communication.comm_title}</TableCell>
                      <TableCell>{communication.message}</TableCell>
                    </TableRow>
                  );
                } else {
                  return "";
                }
              })
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SchoolReport;
